import {
  Banner,
  BannerTypes,
  Typography,
} from "@sunrun/experience-ui-components";

const PPC_REQUIRED_WARNING_MESSAGE =
  "Your permit office requires a couple pieces of additional information on the permit — after you approve the final design, we will schedule a quick visit to your home.";

const PpcRequiredWarningBanner = () => (
  <div data-testid="ppc-required-warning-banner">
    <Banner show showClose={false} bannerType={BannerTypes.WarningLight}>
      <Typography>{PPC_REQUIRED_WARNING_MESSAGE}</Typography>
    </Banner>
  </div>
);

export { PpcRequiredWarningBanner, PPC_REQUIRED_WARNING_MESSAGE };
